import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const LegalPolicyEditor = Loadable(lazy(() => import('../legalPolicies/LegalPolicyEditor')));
const LegalPolicyPreview = Loadable(lazy(() => import('../legalPolicies/LegalPolicyPreview')));

const TermsAndConditionsRoutes = [
  { path: '/dashboard/terms-and-conditions', element: <LegalPolicyEditor policyType="terms" />, auth: authRoles.admin },
  { path: '/dashboard/terms-and-conditions/preview', element: <LegalPolicyPreview policyType="terms" />, auth: authRoles.admin },
];

export default TermsAndConditionsRoutes;
